//  Componente stateless per visualizzazione icona svg di Facebook
import React from 'react';

const FacebookIcon = () => {
  return (
    <svg role="graphics-symbol" aria-label="Facebook" width="40px" height="40px" viewBox="0 0 40 40" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="facebook" transform="translate(12.000000, 4.000000)" fill='var(--social-icon)' fillRule="nonzero">
          <path d="M4.79375,32 L4.79375,17.6875 L0,17.6875 L0,12 L4.79375,12 L4.79375,7.51875 C4.79375,2.65 7.76875,0 12.1125,0 C14.19375,0 15.98125,0.15625 16.5,0.225 L16.5,5.3125 L13.4875,5.3125 C11.125,5.3125 10.66875,6.4375 10.66875,8.08125 L10.66875,12 L16,12 L15.26875,17.6875 L10.66875,17.6875 L10.66875,32" id="Shape" />
        </g>
      </g>
    </svg>
  );
};

export default FacebookIcon;
